<template>
  <div class="report-container">
    <q-card
      square
      v-for="report in operationReports"
      :key="report.id"
      class="report-card"
    >
      <div :class="report.status" class="report-status">
        {{ firstCharCapital(report.status)[0] }}
        <q-tooltip>Status :{{ firstCharCapital(report.status) }}</q-tooltip>
      </div>
      <div class="report-content">
        <div class="report-type">
          <div class="strech-me">
            {{ report.type.toUpperCase() }}
            <q-tooltip>Type</q-tooltip>
          </div>
          <div class="report-setting">
            <q-icon
              style="cursor:pointer"
              color="grey-7"
              name="fas fa-ellipsis-h"
            ></q-icon>
            <q-menu content-class="text-grey-7" auto-close>
              <q-list style="min-width: 150px">
                <q-item
                  clickable
                  v-for="(item, index) in reportActions"
                  :key="index"
                  @click="item.actions(report)"
                >
                  <q-item-section>{{ item.name }}</q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </div>
        </div>
        <div class="report-locations">
          <q-tooltip>
            Locations:
            <span
              class="comma"
              v-for="location in report.locations"
              :key="location.id"
              >{{ location.name }}</span
            >
          </q-tooltip>
          <span v-for="location in report.locations" :key="location.id">{{
            location.name
          }}</span>
        </div>
        <div class="report-classes">
          <span class="bolder">Created At:</span>
          <span>{{ localeDateConventer(report.created_at) }}</span>
        </div>
        <div class="report-dates">
          <div class="bolder">Period:</div>
          <div>
            {{ usaDateFormatter(report.from_date) }}
            <q-tooltip>Start Date</q-tooltip>
          </div>
          <div style="margin:0px 5px">-</div>
          <div>
            {{ usaDateFormatter(report.to_date) }}
            <q-tooltip>End Date</q-tooltip>
          </div>
        </div>
      </div>
    </q-card>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      reportActions: [
        {
          name: "Delete",
          actions: this.delete,
        },
        {
          name: "Report",
          actions: this.reportDetail,
        },
      ],
    };
  },
  methods: {
    delete({ id }) {
      this.remove = true;
      this.$store.commit("reports/SET_SELECTED_REPORT", id);
    },
    reportDetail({ content }) {
      console.log(content);
    },
  },
  computed: {
    remove: {
      get() {
        return this.$store.state.reports.remove;
      },
      set(val) {
        this.$store.commit("reports/SET_REMOVE", val);
      },
    },
    localeDateConventer() {
      return (val) => new Date(val).toLocaleDateString("en-US");
    },
    usaDateFormatter() {
      return (val) => new Date(val).toLocaleDateString("en-US");
    },
    firstCharCapital() {
      return (val) => val.charAt(0).toUpperCase() + val.slice(1);
    },
    operationReports() {
      return this.$store.state.reports.operationReports;
    },
  },
};
</script>

<style lang="scss" scoped>
.comma {
  &::after {
    content: " , ";
  }
  &:last-child::after {
    content: " ";
  }
}
.bolder {
  font-weight: 500;
  margin-right: 5px;
}
.working {
  background: orange;
  height: 50px;
  width: 50px;
  border-radius: 50% !important;
}
.failed {
  background: #f44336;
  height: 50px;
  width: 50px;
  border-radius: 50% !important;
}
.finished {
  background: #76ff03;
  height: 50px;
  width: 50px;
  border-radius: 50% !important;
}
.report-container {
  display: flex;
  flex-flow: row wrap;
  .report-card {
    margin: 0px 10px;
    padding: 15px;
    margin-bottom: 10px;
    display: flex;
    flex-flow: row nowrap;
    flex: 0 1 calc(50% - 20px);
    .report-status {
      align-items: center;
      display: flex;
      justify-content: center;
      font-size: 20px;
      color: #fff;
      flex: 0 0 50px;
    }
    .report-content {
      flex: 0 1 calc(100% - 50px);
      margin-left: 10px;
      font-size: 14px;

      .report-type {
        display: flex;
        flex-flow: row nowrap;
        font-weight: bold;
        .strech-me {
          flex: 1;
        }
      }
      .report-locations {
        font-weight: 300;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1; /* number of lines to show */
        -webkit-box-orient: vertical;
        span {
          &::after {
            content: " , ";
          }
          &:last-child::after {
            content: " ";
          }
        }
      }
      .report-dates {
        display: flex;
        flex-flow: row wrap;
      }
    }
  }
}
@media only screen and (max-width: 1024px) {
  .report-container {
    flex: 1;
    flex-flow: column nowrap;
  }
}
</style>
